var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinShieldAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 129,
    viewBox: "0 0 111 129",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4786_67493)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2332 99.4224C36.4502 92.2574 25.3703 81.35 18.9256 70.9152C7.99201 53.2338 8.7646 27.6602 9.60564 17.4797L10.476 6.86886L20.1871 11.2208C22.6125 12.3161 26.7883 13.6168 32.881 13.6168C33.1255 13.6168 33.3798 13.6168 33.6242 13.6168C42.2009 13.4701 47.3645 9.2844 49.6823 6.8004L55.1882 0.90332L60.6941 6.79064C63.0118 9.27464 68.1852 13.4701 76.7717 13.6168C77.0357 13.6168 77.29 13.6168 77.5443 13.6168C83.5978 13.6168 87.7541 12.3161 90.1794 11.2305L99.9101 6.86886L100.78 17.4797C101.612 27.6602 102.375 53.2533 91.4606 70.9054C80.4683 88.6847 65.6614 98.5957 59.8743 103.418L56.9192 106.004L52.5715 103.418L46.2332 99.4224ZM24.2261 27.9732C24.1772 38.7894 25.5365 52.9502 31.7368 62.984C37.3796 72.1083 45.2619 80.1765 55.1882 86.9928C65.1144 80.1765 72.9968 72.1083 78.6396 62.984C84.8398 52.9697 86.1992 38.7991 86.1503 27.9732C83.3729 28.4426 80.4781 28.6773 77.5051 28.6773C77.1726 28.6773 76.8401 28.6773 76.5076 28.6773C66.8259 28.511 59.7063 25.0491 55.1882 21.8609C50.67 25.0491 43.5505 28.511 33.859 28.6773C33.5362 28.6773 33.2135 28.6773 32.9006 28.6773C29.9178 28.6773 27.0035 28.4426 24.2163 27.9732H24.2261Z",
    fill: "url(#paint0_linear_4786_67493)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5966 101.172L47.6188 97.9158C40.6362 93.114 29.1061 84.0092 20.4316 69.9755C9.78167 52.744 10.5445 27.63 11.366 17.6256L12.031 9.52807L19.4439 12.8531C22.0355 14.0169 26.4558 15.4056 32.8614 15.4056C33.1157 15.4056 33.37 15.4056 33.634 15.4056C42.8659 15.2491 48.4598 10.7114 50.9732 8.02201L55.1784 3.52344L59.3836 8.02201C61.897 10.7212 67.4909 15.2589 76.7326 15.4056C77.0064 15.4056 77.2704 15.4056 77.5345 15.4056C83.901 15.4056 88.3213 14.0169 90.9031 12.8629L98.3356 9.53786L99.0006 17.6451C99.8221 27.6496 100.575 52.7929 89.935 69.9951C78.9721 87.7157 65.2478 96.39 59.3229 101.182L56.4204 103.607L52.5966 101.182V101.172ZM22.4658 25.8306C22.2408 36.3828 23.2383 52.6364 30.221 63.922C38.2598 76.919 49.2031 85.1339 55.1882 89.1435C61.1733 85.1339 72.1166 76.919 80.1554 63.922C87.1282 52.6559 88.1257 36.3925 87.9008 25.8306C84.9865 26.4565 81.5148 26.8966 77.5051 26.8966C77.1824 26.8966 76.8695 26.8966 76.537 26.8966C66.7672 26.7303 59.7161 23.1021 55.1784 19.6499C50.6505 23.1021 43.5896 26.7303 33.8198 26.8966C33.5069 26.8966 33.1939 26.8966 32.8908 26.8966C28.8616 26.8966 25.3703 26.4565 22.456 25.8306H22.4658Z",
    fill: "url(#paint1_linear_4786_67493)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4786_67493)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6931 95.6303C54.4482 95.4574 54.0218 95.1843 53.4594 94.8293C48.8328 91.8892 34.7626 82.9416 24.8472 66.8394C12.9179 47.4786 16.9548 17.2314 17.1272 15.957L17.3267 14.5279L18.4607 15.4109C18.5151 15.4473 23.7949 19.4614 34.4904 19.4614C34.4904 19.4614 34.9803 19.4614 35.2343 19.4614C47.971 19.243 53.8676 10.887 54.5026 9.93121L55.1921 8.89355L55.8815 9.93121C56.5166 10.887 62.4132 19.243 75.1499 19.4614C75.4039 19.4614 75.6488 19.4614 75.8937 19.4614C86.5893 19.4614 91.869 15.4473 91.9235 15.4109L93.0484 14.5371L93.2479 15.957C93.4294 17.2314 97.4572 47.4786 85.5279 66.8394C75.6035 82.9325 61.5332 91.8892 56.9066 94.8293C56.3351 95.1934 55.9178 95.4574 55.6729 95.6303L55.1921 95.9762L54.7113 95.6303H54.6931Z",
    fill: "#274E0A"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2259 16.2056C93.2259 16.2056 87.4797 20.7006 75.561 20.506C62.1501 20.2836 55.9127 11.516 55.1898 10.4316C54.4669 11.5253 48.2295 20.2836 34.8186 20.506C22.8999 20.7099 17.1537 16.2056 17.1537 16.2056C17.1537 16.2056 12.7514 47.7726 24.9204 67.4487C36.2367 85.7438 52.9006 94.8913 55.1898 96.5225C57.479 94.8913 74.143 85.7438 85.4593 67.4487C97.6282 47.7726 93.2259 16.2056 93.2259 16.2056Z",
    fill: "url(#paint2_radial_4786_67493)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2442 30.9191C50.6306 29.5327 50.4621 29.7012 51.4792 28.7631C54.8768 25.6294 60.1688 25.8996 63.6727 28.9137C65.2956 30.3098 66.9358 31.8325 69.6178 34.5145C72.2679 37.1646 73.8012 38.8126 75.1992 40.4322C78.2565 43.9741 78.4822 49.3363 75.3293 52.7934C74.422 53.7882 74.6203 53.6076 73.2765 54.9514C71.9327 56.2952 72.1138 56.0964 71.119 57.0037C67.6619 60.1567 62.2997 59.931 58.7577 56.8736C57.1381 55.4756 55.3493 54.123 52.6992 51.4729C50.0172 48.7909 48.6353 46.9701 47.2393 45.3472C44.2251 41.8432 43.955 36.5512 47.0886 33.1537C48.0267 32.1366 47.8581 32.3052 49.2442 30.9191Z",
    fill: "#446011"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5808 59.6218C42.6281 55.0724 50.1428 48.598 50.1428 48.598L52.8393 51.2945L55.5358 53.991C55.5358 53.991 49.0613 61.5057 44.512 66.5529C42.6318 68.6388 39.4419 68.6632 37.4563 66.6775C35.4706 64.6918 35.495 61.5019 37.5808 59.6218Z",
    fill: "#446011"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.2442 30.9191C50.6306 29.5327 50.4621 29.7012 51.4792 28.7631C54.8768 25.6294 60.1688 25.8996 63.6727 28.9137C65.2956 30.3098 66.9358 31.8325 69.6178 34.5145C72.2679 37.1646 73.8012 38.8126 75.1992 40.4322C78.2565 43.9741 78.4822 49.3363 75.3293 52.7934C74.422 53.7882 74.6203 53.6076 73.2765 54.9514C71.9327 56.2952 72.1138 56.0964 71.119 57.0037C67.6619 60.1567 62.2997 59.931 58.7577 56.8736C57.1381 55.4756 55.3493 54.123 52.6992 51.4729C50.0172 48.7909 48.6353 46.9701 47.2393 45.3472C44.2251 41.8432 43.955 36.5512 47.0886 33.1537C48.0267 32.1366 47.8581 32.3052 49.2442 30.9191Z",
    stroke: "white",
    strokeOpacity: 0.88,
    strokeWidth: 5.08459,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5808 59.6218C42.6281 55.0724 50.1428 48.598 50.1428 48.598L52.8393 51.2945L55.5358 53.991C55.5358 53.991 49.0613 61.5057 44.512 66.5529C42.6318 68.6388 39.4419 68.6632 37.4563 66.6775C35.4706 64.6918 35.495 61.5019 37.5808 59.6218Z",
    stroke: "white",
    strokeOpacity: 0.88,
    strokeWidth: 5.08459,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      mixBlendMode: "soft-light"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4786_67493",
    x: 0.216427,
    y: 0.90332,
    width: 109.946,
    height: 127.479,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.4273
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.47577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4786_67493"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4786_67493",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4786_67493",
    x: 16.333,
    y: 8.89355,
    width: 77.7129,
    height: 89.0068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.37789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.278431 0 0 0 0 0.101961 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4786_67493"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4786_67493",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4786_67493",
    x1: 28.8718,
    y1: 5.72593,
    x2: 84.6763,
    y2: 75.1716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A84D11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4786_67493",
    x1: 55.1825,
    y1: 3.52344,
    x2: 55.1825,
    y2: 103.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C26324"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4786_67493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.1898 53.4724) scale(40.9833 40.9833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83B12F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446011"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinShieldAsset);
export default __webpack_public_path__ + "static/media/spin-shield-asset.b994ea79e774094c29653246e676d5aa.svg";
export { ForwardRef as ReactComponent };